import { styled } from '@mui/material/styles';
import { EmailFieldProps, EmailField as RaEmailField } from 'react-admin';

const StyledEmailField = styled(RaEmailField, { slot: 'Root' })(() => ({}));

function EmailField({ variant = 'body1', ...props }: EmailFieldProps): JSX.Element {
  return <StyledEmailField {...props} variant={variant} />;
}

export { EmailField };
export type { EmailFieldProps };
